import { ListingImageType } from '../../util/listings/listingImages';

export const determineImageType = (listingImageSrc: string, stockPhotos: string[]) => {
  // need to do this because the listingImageSrc might have smart-resize operation appended
  const isStockPhoto = stockPhotos.some((stockPhoto) => listingImageSrc?.includes(stockPhoto));

  return isStockPhoto ? ListingImageType.Stock : ListingImageType.UserUploaded;
};
